import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_USERS',
    icon: 'UserIcon',
    action: constants.action.permissionUserView,
    resource: constants.resource.user,
    children: [
      {
        title: 'DEBTIA_LIST',
        route: 'users-list',
        action: constants.action.permissionUserView,
        resource: constants.resource.user,
      },
      {
        title: 'DEBTIA_ADD',
        route: 'users-add',
        action: constants.action.permissionUserAdd,
        resource: constants.resource.user,
      },
    ],
  },
]
